/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import iconRobotIa from 'assets/images/icon_robot_ia.svg';
import { Card } from './styles';

interface AiManagementSummaryCardProps {
  title?: string;
  badges?: string[];
  className?: string;
  children: React.ReactNode;
}

const LONG_TEXT = 700;
const LONG_INLINE_TEXT = 220;

const AiManagementSummaryCard: React.FC<AiManagementSummaryCardProps> = ({
  title = 'Resumo',
  badges = [],
  className = '',
  children,
}) => {
  const [expanded, setExpanded] = useState(false);
  const inline = !title;
  const long =
    typeof children === 'string' && children.length > (inline ? LONG_INLINE_TEXT : LONG_TEXT);
  const icon = <img src={iconRobotIa} alt="" aria-hidden className="summary-icon mr-2" />;
  const body = (
    <>
      <div
        className={`summary-text ${long && !expanded ? 'is-clamped' : ''} ${
          inline ? 'is-inline' : ''
        }`}
      >
        {children}
      </div>
      {long ? (
        <button
          type="button"
          className="btn btn-link btn-sm p-0 mt-1"
          onClick={() => setExpanded((current) => !current)}
          aria-expanded={expanded}
        >
          {expanded ? 'Ver menos' : 'Ver mais'}
        </button>
      ) : null}
    </>
  );

  return (
    <Card className={`px-3 py-3 ${className}`}>
      {inline ? (
        <div className="d-flex align-items-start">
          {icon}
          <div className="flex-grow-1">{body}</div>
        </div>
      ) : (
        <>
          <div className="summary-title d-flex align-items-center font-weight-bold mb-1">
            {icon}
            {title}
          </div>
          {body}
        </>
      )}
      {badges.length ? (
        <div className="mt-2">
          {badges.map((badge) => (
            <span key={badge} className="badge badge-secondary mr-2">
              {badge}
            </span>
          ))}
        </div>
      ) : null}
    </Card>
  );
};

export default AiManagementSummaryCard;
